module.exports = __webpack_public_path__ + "media/images/fpp-arrow-60d6a71f6bca77818c8389c1dc6fa01e.png";